import React, { useState, useEffect, useContext, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Form,
  Button,
  Row,
  Col,
  Card,
  Input,
  CardBody,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'

const FormPage = (props) => {
  const generalContext = useContext(GeneralContext)
  const { loading, setLoading } = generalContext

  const inputUrlRef = useRef(null)

  const [storeName, setStoreName] = useState('')
  const [storeUrl, setStoreUrl] = useState('')
  const [domain, setDomain] = useState('')
  const [profit, setProfit] = useState('')
  const [urlAvailable, setUrlAvailable] = useState(null)
  const [saveOrderModal, setSaveOrderModal] = useState(false)

  const toggleSaveOrderModal = () => setSaveOrderModal(!saveOrderModal)

  async function fetchStoreInit() {
    try {
      setLoading(true)
      const response = await ApiService.getStoreInit()
      if (response.data.success) {
        setDomain(response.data.domain)
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async () => {
      await fetchStoreInit()
    })()
  }, []) // eslint-disable-line

  const handleSubmit = async (e) => {
    e.preventDefault()
    toggleSaveOrderModal()
  }

  const save = async () => {
    toggleSaveOrderModal()
    setLoading(true)
    const data = {
      name: storeName,
      url: storeUrl,
      profit,
    }
    try {
      const response = await ApiService.createStore(data)
      if (!isEmpty(response.data)) {
        if (response.data.success) {
          toastr.success(`Tienda creada, ahora selecciona tus productos.`, '¡Éxito!')
          props.history.push(`/mi-tienda/${response.data.id}/productos`)
        }
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  const checkAvailability = async (url) => {
    try {
      setLoading(true)
      const response = await ApiService.checkStoreUrl(url)
      if (response.data.success) {
        setUrlAvailable(response.data.available)
        if (!response.data.available) {
          toastr.error(`URL no disponible, por favor escribe otra.`, 'Error')
          inputUrlRef.current.focus()
        }
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <Form id="create" method="POST" onSubmit={handleSubmit}>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col sm={4}>
                    <FormGroup>
                      <Label>
                        Nombre de tu tienda
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        required
                        maxLength="50"
                        onChange={event => setStoreName(event.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={5}>
                    <FormGroup>
                      <Label>
                        URL
                      </Label>
                      <InputGroup>
                        <Input
                          type="text"
                          className="form-control"
                          required
                          maxLength="50"
                          value={storeUrl}
                          innerRef={inputUrlRef}
                          onChange={event => {
                            const urlNoSpaces = event.target.value.replace(/ /g, '-')
                            const url = urlNoSpaces.replace(/[^a-zA-Z-]/g, '')
                            setStoreUrl(url)
                          }}
                          onBlur={event => checkAvailability((event.target.value))}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>.{domain}</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup>
                      <Label>
                        Porcentaje de ganancia
                      </Label>
                      <Col sm="12" style={{ display: 'inline-flex' }}>
                        <FormGroup check>
                          <Label check style={{ cursor: 'pointer' }}>
                            <Input
                              type="radio"
                              name="profit"
                              value={20}
                              style={{ cursor: 'pointer' }}
                              onChange={(event) => setProfit(event.target.value) }
                            />{' '}
                            20%
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check style={{ cursor: 'pointer', marginLeft: '10px' }}>
                            <Input
                              type="radio"
                              name="profit"
                              value={30}
                              style={{ cursor: 'pointer' }}
                              onChange={(event) => setProfit(event.target.value) }
                            />{' '}
                            30%
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check style={{ cursor: 'pointer', marginLeft: '10px' }}>
                            <Input
                              type="radio"
                              name="profit"
                              value={50}
                              style={{ cursor: 'pointer' }}
                              onChange={(event) => setProfit(event.target.value) }
                            />
                            50%
                          </Label>
                        </FormGroup>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card style={{textAlign: 'right'}}>
              <CardBody>
                <Button
                  onClick={() => { window.history.go(-1) }}
                  className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                >
                  Cancelar
                </Button>

                <Button
                  type="submit"
                  color="primary"
                  className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                  disabled={loading || isEmpty(storeName) || isEmpty(storeUrl) || isEmpty(profit) || !urlAvailable}
                >
                  <i className={`mdi mdi-check`}></i> Siguiente
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Form>
      <div>
        <Modal isOpen={saveOrderModal} toggle={toggleSaveOrderModal}>
          <ModalHeader toggle={toggleSaveOrderModal}>Crear mi tienda</ModalHeader>
          <ModalBody>
            ¿Está seguro que desea crear su tienda?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleSaveOrderModal}>Cancelar</Button>{' '}
            <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={() => save()}>Crear mi tienda</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(FormPage)
